<template>
    <div>
        
        <el-row style="margin-bottom:20px;">
        <el-col :lg="6" :offset="2">
         品牌: <el-tag type="info" effect="dark">{{this.orderReturnDetail.brand_id == 1 ? 'N牌':'S牌'}}</el-tag>
         
        </el-col>
        <el-col :lg="6" :offset="2">
        店櫃: <el-tag type="info" effect="dark">{{this.orderReturnDetail.shop_name}}</el-tag>
        
        </el-col>
        <el-col :lg="6">
            建單: <el-tag type="info" effect="dark">{{this.orderReturnDetail.user_name}}</el-tag>
            
        </el-col>
        
    </el-row >
    <el-row style="margin-bottom:20px;">
               <el-col :lg="6" :offset="2">
        單號: <el-tag type="info" effect="dark">{{this.orderReturnDetail.id}}</el-tag>
        </el-col>
        <el-col :lg="6" :offset="2">
            日期: <el-tag type="info" effect="dark">{{this.orderReturnDetail.create_datetime}}</el-tag>
            
        </el-col>
        <el-col :lg="6">
            原訂單: <el-tag type="info" effect="dark">{{this.orderReturnDetail.order_id}}</el-tag>
            
        </el-col>
    </el-row>
        <el-row >
            <el-col :lg="6" :offset="2">
                 <el-col :lg="6" :offset="2">
        姓名: <el-tag type="info" effect="dark">{{this.orderReturnDetail.member_name}}</el-tag>
        </el-col>
            </el-col>
            <el-col :lg="6" :offset="2">
                電話: <el-tag type="info" effect="dark">{{this.orderReturnDetail.phone}}</el-tag>
                
            </el-col>
            <el-col :lg="6">
                卡號: <el-tag type="info" effect="dark">{{this.orderReturnDetail.card_number}}</el-tag>
                
            </el-col>
        </el-row>
        <hr />
    
    <el-row style="margin-bottom:20px;">
      
        <el-col :lg="6" :offset="2">
        點數: <el-tag type="info" effect="dark">{{this.orderReturnDetail.get_point}}</el-tag>
        
        </el-col>
          <el-col :lg="6" :offset="2">
        現金: <el-tag type="info" effect="dark">{{this.orderReturnDetail.total}}</el-tag>
        
        </el-col>
        <el-col :lg="6">
            總計: <el-tag type="info" effect="dark">{{this.orderReturnDetail.total}}</el-tag>
        </el-col>
        
    </el-row>
    <el-row style="margin-bottom:20px;">
        <el-col :lg="6" :offset="2">
            備註: <el-tag type="info" effect="dark">{{this.orderReturnDetail.note}}</el-tag>
            
        </el-col>
        <el-col :lg="18"></el-col>
    </el-row>
     <el-row>
        <el-col :lg="4" :offset="20">
             <el-button type="primary" size="default" @click="chreTab()" >退換貨記錄</el-button>
        </el-col>
    </el-row>
  <el-row>
          <el-col :lg="22" :offset="2">
              退貨單品清單:
              <el-table
                  :data="productDetail"
                  style="width: 100%"
                  
                  >
                  <el-table-column label="產品編號" prop="id">
                      <template slot-scope="scope">
                          {{scope.row.id}}
                      </template>
                  </el-table-column>
                  <el-table-column label="系列別" prop="className"></el-table-column>
                  <el-table-column
                      prop="name"
                      label="名稱"
                      >
                  </el-table-column>
                  <el-table-column label="數量" prop="qty" >
                    
                  </el-table-column>
                  <el-table-column label="單價" prop="price" ></el-table-column>
                  <el-table-column label="小計" prop="paid" ></el-table-column>
              </el-table>
          </el-col>
      </el-row>
        <el-row style="margin-top: 20px;">
        <el-col :lg="11">
          
              <el-table
                  :data="shopPerformance"
                  style="width: 100%"
                  
                  >
                  <el-table-column label="店櫃" prop="name">
                    
                  </el-table-column>
                  <el-table-column label="業績" prop="count"></el-table-column>
                
              </el-table>
        </el-col>
        <el-col :lg="1">
        </el-col>
        <el-col :lg="11" :offset="1">
           
              <el-table
                  :data="userPerformance"
                  style="width: 100%"
                 
                  
                  >
                  <el-table-column label="美容師" prop="name">
                  
                  </el-table-column>
                  <el-table-column label="業績" prop="count"></el-table-column>
                 
              </el-table>
        </el-col>
    </el-row>

    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'detail',
        props: {
            orderKey: String
        },
        data() {
            return {
              orderReturnDetail: [],
              productDetail: [],
              bundleDetail: [],
              qtys: [],
              memberName: '',
              userPerformance: [],
              shopPerformance: [] 
            }
        },
        computed: mapGetters(["getOrderReturnDetail", "getProductDetail", "getUserPerformance", "getShopPerformance"]),
        methods: {
            ...mapActions(["fetchOrderReturnDetail", "fetchProductDetail"]),
            async fetchChangeDetail(){
                const data = {_key: this.orderKey}
                await this.$store.dispatch('fetchOrderReturnDetail', data)
                this.orderReturnDetail = this.getOrderReturnDetail
                this.userPerformance = this.getUserPerformance
                this.shopPerformance = this.getShopPerformance
                this.fetchProduct(this.orderReturnDetail.return_items)
                
            },
            async fetchProduct(items){
                for (var i = 0;i < items.length; i++){
                     const data = {_key: items[i]._key, type: 1}
               await this.$store.dispatch('fetchProductDetail', data)
                 this.productDetail.push({
                         name: this.getProductDetail.name,
                         id: this.getProductDetail.id,
                         className: this.getProductDetail.class.name,
                         qty: items[i].qty,
                         price: items[i].price ,
                         paid: items[i].paid,
                         qty: items[i].qty
                         
                 })
                     
                }
      
            },
            chreTab(){
                this.$emit('chreListTabs', this.orderKey)
            },
        },
        created() {
            this.fetchChangeDetail()
            
        },
    }
</script>

<style lang="scss" scoped>
    
</style>